import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from '../../../../classes/User';
import { ROLES } from '../../../data/roles';
import { GlobalService } from '../../../services/global.service';
import { ModelService } from '../../../services/model.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  id: number;
  contentVisible: boolean = false;
  userData: User = new User( );

  role_name: string = "";

  constructor ( private route: ActivatedRoute, private global: GlobalService, private model: ModelService ) {
    this.global.setDocumentTitle( 'User Details' );
  }

  ngOnInit ( ) {
    this.route.params.subscribe( params => {
       this.id = +params['id'];
       this.model.getUserDataByID( this.id, ( user ) => {
         this.userData = user;
         ROLES.forEach( ( element, index, array ) => { if ( element.data == user.role ) this.role_name = element.name });
         this.contentVisible = true;
       });
    });
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/users/user/user.component.ts